import LineLoader from '../SkeletonLoader/LineLoader';
import { ILineLoader } from '../SkeletonLoader/types';
import styles from './TableLoader.module.scss';
import cx from 'classnames';

interface ITableLoader extends ILineLoader {
  numberOfLines?: number;
  className?: string;
}
const TableLoader = ({ numberOfLines, className }: ITableLoader) => {
  return (
    <LineLoader
      numberOfLines={numberOfLines}
      dimenshionUnit="px"
      lineStyle={cx(styles.tableLineLoader, className)}
    />
  );
};

export default TableLoader;
